module.exports = __webpack_public_path__ + "static/media/bg6.48f2f36c.jpg";